export const PRIVATE = 'private';
export const EVERYONE = 'everyone';
export const SPECIFIC = 'specific';